import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/config'; // Initialize i18n before app loads
import App from './App';
import { initAnalytics } from './analytics';

initAnalytics(); // PostHog (prod-only, cookieless; no-op in dev)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
